export enum SurveyVariableConditionFilterUsersScopeTypeEnum {
  None = 'none',
  All = 'all',
  Manual = 'manual',
  MyCompanyProductTeams = 'my_company_product_teams',
}

export const SurveyVariableConditionFilterUsersScopeTypeEnumLabels: Record<SurveyVariableConditionFilterUsersScopeTypeEnum, string> = {
  [SurveyVariableConditionFilterUsersScopeTypeEnum.None]: 'Ningún usuario',
  [SurveyVariableConditionFilterUsersScopeTypeEnum.All]: 'Todos los usuarios',
  [SurveyVariableConditionFilterUsersScopeTypeEnum.MyCompanyProductTeams]: 'Equipos de los proyectos de la persona preguntada',
  [SurveyVariableConditionFilterUsersScopeTypeEnum.Manual]: 'Selección manual de usuarios',
};

export const SurveyVariableConditionFilterUsersScopeTypeEnumOptions: SurveyVariableConditionFilterUsersScopeTypeEnum[] = [
  SurveyVariableConditionFilterUsersScopeTypeEnum.None,
  SurveyVariableConditionFilterUsersScopeTypeEnum.All,
  SurveyVariableConditionFilterUsersScopeTypeEnum.MyCompanyProductTeams,
  SurveyVariableConditionFilterUsersScopeTypeEnum.Manual,
];
